import React, { useEffect, useState } from 'react'
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import Container from 'react-bootstrap/Container';
import Link from '../Link';
import messages from '../../locale/messages';
import history from '../../history';
import dashboardNavIcon from '/public/dashboard/dashboardNavIcon.svg'
import bookingNavIcon from '/public/dashboard/bookingNavIcon.svg';
import paymentNavIcon from '/public/dashboard/paymentNavIcon.svg';
import profileNavIcon from '/public/dashboard/profileNavIcon.svg';
import s from "./SubNavBar.css"

function SubnavBar() {
    const [location, setLocation] = useState('');

    useEffect(() => {
        if (history.location) {
            setLocation(history.location.pathname);
        }
    });

    return (
        <div className={cx(s.subNavBarContainer, 'hidden-print')}>
            <Container>
                <ul className={s.subNavBarList}>
                    <li>
                        <Link to="/dashboard" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/dashboard/' || location === '/dashboard') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={dashboardNavIcon} alt="Dashboard Icon" />
                            </div>
                            <FormattedMessage {...messages.dashboard} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/bookings/upcoming" className={cx(s.subNavBarItem, 'subNavBarItemRtl', {
                            [s.active]: location === '/bookings/upcoming' || location === '/bookings/previous' ||
                                location.startsWith('/booking/') || location.startsWith('/tracking/') || location.startsWith('/chat-message/') || location.startsWith('/order/')
                        })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={bookingNavIcon} alt="Booking Icon" />
                            </div>
                            <FormattedMessage {...messages.myBookings} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/payment-method" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: ['/payment-method', '/payment-method/', '/add-wallet', '/add-card', '/add-wallet/', '/add-card/'].includes(location) })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={paymentNavIcon} alt="Payment Icon" />
                            </div>
                            <FormattedMessage {...messages.paymentMethodText} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/profile" className={cx(s.subNavBarItem, 'subNavBarItemRtl', { [s.active]: (location === '/profile' || location === '/profile/') })}>
                            <div className={s.subNavBarImgContainer}>
                                <img src={profileNavIcon} alt="Profile Icon" />
                            </div>
                            <FormattedMessage {...messages.profile} />
                        </Link>
                    </li>
                </ul>
            </Container>
        </div>
    );
}


export default injectIntl(withStyles(s)(SubnavBar));
